import { packageInfo as codecInfo } from '@polkadot/types-codec/packageInfo';
import { packageInfo as createInfo } from '@polkadot/types-create/packageInfo';
export default [codecInfo, createInfo];
